export enum FacetSortTypeEnum {
  ALPHABETICALLY = 'ALPHABETICALLY',
  RESULTS_NUMBER = 'RESULTS_NUMBER'
}
